import {
    convertPersianDateToUniversalDate,
    convertUniversalDateToPersianDate,
    RaikoBaseCardContainer, RaikoConfirmDialog,
    RaikoDatePicker, RaikoFlexFirstChildGrowOne,
    RaikoGridOneColumn,
    RaikoGridThreeColumn,
    RaikoHtmlTextEditor,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined,
    RaikoSimpleMultiLineInputOutlined, RaikoToggleOutlined,
    showServerErrorMessage,
    showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {useEffect, useState} from "react";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {EtekafService} from "../../../serverService/etekafService/EtekafService";


export default function EtecafBasicInfo({etecafId}){

    const service = new EtekafService();
    const loading = new LoadingHelper(useLoadingDispatcher());

    const [title, setTitle] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [description, setDescription] = useState("");
    const [rules, setRules] = useState("");
    const [requestForNewAccommodation, setRequestForNewAccommodation] = useState(false);
    const [actionButtonLoadingState, setActionButtonLoadingState] = useState(false);
    const [dialogRequestForNewAccommodation, setDialogRequestForNewAccommodation] = useState(false);


    useEffect(() => {
        getEtecafBasicInfoFromServer()
    }, [etecafId]);

    function getEtecafBasicInfoFromServer() {
        loading.show()
        service.getEtekafDetailData(etecafId)
            .then(response => {
                setTitle(response.title)
                setStartDate(convertUniversalDateToPersianDate(response.startDate))
                setEndDate(convertUniversalDateToPersianDate(response.endDate))
                setRules(response.rules)
                setDescription(response.description)
                setRequestForNewAccommodation(response.acceptation)
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }

    const convertStartDateTypeForServer = convertPersianDateToUniversalDate(startDate)
    const convertEndDateTypeForServer = convertPersianDateToUniversalDate(endDate)
    function handlUpdateEtekafDetailData() {
        setActionButtonLoadingState(true);
        service.updateEtekafDetail(etecafId,title,convertStartDateTypeForServer,convertEndDateTypeForServer,description,rules)
        .then(response => {
                showSuccessMessage("اطلاعات با موفقیت بروزرسانی شد")
            }).catch(reason => {
                showServerErrorMessage(reason)
            }).finally(_ => {
            setActionButtonLoadingState(false)
            })
    }

    function handleUpdateEtekafEnabledState (){
        if(requestForNewAccommodation){
            service.updateEtekafEnabledState(etecafId,false)
                .then(response => {
                    setRequestForNewAccommodation(false)
                    showSuccessMessage("درخواست اسکان جدید با موفقیت غیر فعال شد")
                }).catch(reason => {
                showServerErrorMessage(reason)
            })
        }else{
            service.updateEtekafEnabledState(etecafId,true)
                .then(response => {
                    setRequestForNewAccommodation(true)
                    showSuccessMessage("درخواست اسکان جدید با موفقیت فعال شد")
                }).catch(reason => {
                showServerErrorMessage(reason)
            })
        }
    }

    function handleOpenDialogRequestForNewAccommodation(){
        setDialogRequestForNewAccommodation(true);
    }
    function handleCloseDialogRequestForNewAccommodation(){
        setDialogRequestForNewAccommodation(false);
    }

    return (
        <>
            <RaikoConfirmDialog
                                pageTitle={"درخواست اسکان"}
                                warningTitle={""}
                                warningDescription={"آیا از تغییر وضعیت این مورد اطمینان دارید؟"}
                                cancelAction={handleCloseDialogRequestForNewAccommodation}
                                cancelButtonTitle={"بیخیال"}
                                openConfirmDialog={dialogRequestForNewAccommodation}
                                doAction={handleUpdateEtekafEnabledState}
                                confirmButtonTitle={"فعالسازی"}
                                />
            <RaikoGridOneColumn>
                <RaikoBaseCardContainer>
                    <RaikoSectionContainer
                        title={"اطلاعات پایه"}
                        hasActionButton
                        actionButtonTitle={"بروزرسانی"}
                        actionButtonOnclickWithValidation={handlUpdateEtekafDetailData}
                        actionButtonLoadingState={actionButtonLoadingState}>
                        <RaikoGridOneColumn>
                            <RaikoGridThreeColumn>
                                <RaikoSimpleInputOutlined
                                    labelText={"عنوان"}
                                    value={title}
                                    setValue={setTitle}
                                    required={true}
                                />
                                <RaikoDatePicker
                                    label={"تاریخ شروع"}
                                    date={startDate}
                                    setDate={setStartDate}
                                    required={true}
                                />
                                <RaikoDatePicker
                                    label={"تاریخ پایان"}
                                    date={endDate}
                                    setDate={setEndDate}
                                    required={true}
                                />
                            </RaikoGridThreeColumn>
                            <RaikoSimpleMultiLineInputOutlined
                                labelText={"توضیحات"}
                                setValue={setDescription}
                                multiline={true}
                                row={10}
                                value={description}
                            />
                            <p>قوانین</p>
                            <RaikoHtmlTextEditor
                                text={rules}
                                setText={setRules}
                            />
                        </RaikoGridOneColumn>
                    </RaikoSectionContainer>
                </RaikoBaseCardContainer>
                <RaikoBaseCardContainer>
                        <RaikoToggleOutlined checked={requestForNewAccommodation}
                                             setChecked={handleOpenDialogRequestForNewAccommodation}
                                             labelText={"درخواست اسکان جدید"}
                        />
                </RaikoBaseCardContainer>
            </RaikoGridOneColumn>
        </>
    )
}